<div style="width: 100%; display: flex; justify-content: center">
  <div *ngIf="processing">{{ processingState }}</div>
</div>
